import { RootState } from "@/store";
import { Content } from "@/types/content";
import { dateComparator } from "@/utils/dateComparator";
import { PayloadAction, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

const contentAdapter = createEntityAdapter<Content>({
  sortComparer: (a, b) => dateComparator(b.create_at || 0, a.create_at || 0),
});

export const contentSlice = createSlice({
  name: "content",
  initialState: contentAdapter.getInitialState(),
  reducers: {
    contentAdd: contentAdapter.upsertOne,
    contentRemove: contentAdapter.removeOne,
    contentReceived: (state, action: PayloadAction<Content[]>) => {
      contentAdapter.upsertMany(state, action.payload);
    },
    contentRemoveAll: (state) => {
      contentAdapter.removeAll(state);
    },
  },
});

export default contentSlice.reducer;

export const { selectAll: selectContentsAll, selectById: selectContentsById, selectEntities: selectContentsEntities, selectIds: selectContentsIds, selectTotal: selectContentsTotal } = contentAdapter.getSelectors<RootState>((state) => state.contents);

export const { contentAdd, contentRemove, contentReceived, contentRemoveAll } = contentSlice.actions;
